import React from "react";

const SvgIos = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M17.465 2.272C18.542 1.006 20.363.063 21.866 0c.192 1.76-.514 3.522-1.556 4.791-1.045 1.268-2.754 2.255-4.432 2.123-.228-1.721.618-3.517 1.587-4.642zm8.549 24.004c-1.247 1.828-2.537 3.646-4.573 3.684-2.004.038-2.646-1.19-4.933-1.19-2.289 0-3.005 1.152-4.897 1.228-1.965.074-3.46-1.975-4.717-3.796-2.568-3.722-4.528-10.525-1.892-15.116 1.305-2.28 3.644-3.722 6.179-3.76 1.93-.036 3.754 1.305 4.933 1.305 1.18 0 3.395-1.61 5.721-1.374.974.04 3.708.394 5.464 2.97-.139.092-3.263 1.916-3.225 5.714.038 4.538 3.964 6.046 4.01 6.067-.037.106-.629 2.153-2.07 4.268z" />
  </svg>
);

export default SvgIos;
